import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const InstallmentsActions = ({ rowData, handleDeleteInstallment, setEditingId, setIsOpen }) => {
    return (
        <span>
            <Tooltip
                title="حذف ویژگی"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => handleDeleteInstallment(rowData)}
                >
                    <DeleteIcon className="text-red-400" />
                </IconButton>
            </Tooltip>

            <Tooltip
                title="تغییر وضعیت سفارش"
                arrow={true}
                placement="bottom"
            >
                <IconButton sx={{ mx: "0.25rem" }}
                    onClick={() => {
                        setEditingId(rowData.id);
                        setIsOpen(true);
                    }}
                >
                    <EditIcon className="text-yellow-400" />
                </IconButton>
            </Tooltip>
        </span>
    );
}

export default InstallmentsActions;
